class ParamStore extends FluxBaseStore
  @storeName = 'ParamStore'

  @handlers =
    SET_PARAM:            'set'
    SET_PARAMS:           'setEach'
    TOGGLE_FACET:         'setFacet'
    RECEIVE_SEARCH:       'overwriteParams'
    DELETE_PARAM:         'deleteParam'
    CLEAR_ALL:            'clearAllTerms'
    HANDLE_UNSUPPORTED:   'handleUnsupported'
    RECEIVED_SEARCH_TABS: 'setUnsupported'

  # Facets that take a multiple values and will be available as an array
  @multiValFacets: [
    'type_ids'
    'grade_ids'
    'subject_ids'
    'feature_ids'
    'instructional_ids'
    'accessibility_ids'
    'language_ids',
    'usage_permission_ids'
    'audience_ids'
    'technology_ids'
    'ccss'
    'ccss_affiliation'
    'concept_ids'
    'keyterm_ids'
    'provider_ids'
    'ss_ids',
    'video_types',
    'publisher_ids'
  ]

  # Facets that only accept a single value
  @singleValFacets: [
    'rating'
    'publisher'
    'lexile_measures',
    'video_length'
  ]

  initialize: ({params} = {params: {}}) ->
    @_params = params if params
    @_unsupportedParams ||= {}

  set: ({key, val}) ->
    val = @_cast val
    if val? and ((Array.isArray(val) and val.length) or (!Array.isArray(val) and val isnt ''))
      @set key: 'sort_by' if key is 'keywords' and val isnt @_params[key]
      @_params[key] = val
    else
      delete @_params[key]
      @_removeStandardsIfInSimpleMode() if key == 'grade_ids'
      @_removePowerSearchParams() if key == 'keywords'

    @emitChange()

  setEach: ({params}) ->
    @set key: key, val: val for key, val of params

  deleteParam: (key) ->
    delete @_params[key]

  setFacet: ({facet}) ->
    @dispatcher.waitFor 'FacetStore', =>
      activeIds = @dispatcher.getStore('FacetStore').active(facet.key).map (facet) -> facet.id
      activeIds = activeIds[0] if facet.key in ParamStore.singleValFacets
      @set key: facet.key, val: activeIds

  clearAllTerms: ->
    @_removeStandardsIfInSimpleMode()
    @dispatcher.waitFor 'FacetStore', =>
      @_params = { keywords: "", search_tab_id: @get("search_tab_id") }
      @emitChange()

  overwriteParams: ({rawSearch, paramsDidChange}) ->
    if paramsDidChange
      @initialize params: rawSearch.search_params
      @emitChange()

  activeFacetContexts: ->
    key for key, vals of @_params when key in ParamStore.multiValFacets or key in ParamStore.singleValFacets or @_isCustom(key)

  getAll: ->
    @_params

  get: (facet) ->
    @_params[facet]

  isActive: (facet, val) ->
    if val?
      if facet in ParamStore.multiValFacets || @_isCustom(facet)
        Array.isArray(@_params[facet]) and val in @_params[facet]
      else
        @_params[facet] is val
    else
      if facet in ParamStore.multiValFacets || @_isCustom(facet)
        @_params[facet]?.length > 0
      else
        @_params[facet]?.toString().length > 0

  toQueryString: ->
    parts = []
    for key, val of @_params when val? and val.length isnt 0
      val = [val] unless Array.isArray(val)
      parts.push "#{@_toUrlParam(key)}=#{v}" for v in val

    if parts.length then "?#{parts.join('&')}" else ''

  title: ->
    if @isActive('keywords') then "#{@get('keywords')} Teacher Resources" else 'All Teacher Resources'

  _toUrlParam: (key) ->
    if key in ParamStore.multiValFacets || @_isCustom(key) then encodeURIComponent("#{key}[]") else key

  _cast: (v) ->
    return v unless typeof v is 'string'
    if v.match(/^\d+$/) then parseInt(v) else v

  # If a child CCSS/SS_ID facet is loaded and grades are not active then the backend will not return a list of facets
  # with the child facet, causing it to be orphaned. So, if all grades are removed we force any remaining
  # child CCSS/SS_ID facets to be removed so that the URL doesn't reflect something different from the UI
  _removeStandardsIfInSimpleMode: ->
    for param in ['ss_ids', 'ccss']
      unless @isActive('grade_ids')
        if @isActive(param)
          active_child   = @dispatcher.getStore('FacetStore').active(param)
          active_parents = (facet.id for facet in active_child when facet.isParent or facet.isSelectAll)
          @set(key: param, val: active_parents) if active_parents.length != active_child.length
        @dispatcher.getStore('PanelStore').resetPanelState(param)
        @dispatcher.getStore('FacetStore').collapseFacets({ key: param })

  _removePowerSearchParams: ->
    for param in ['kw_and', 'kw_or', 'kw_not', 'kw_phrase']
      delete @_params[param]

  extraFilters: ->
    return 'concept_ids' if @_params['concept_ids']
    return 'keyterm_ids' if @_params['keyterm_ids']
    return 'publisher_ids' if @_params['publisher_ids']

  _isCustom: (key) ->
    key.startsWith('custom_facet_')

  # Move to @_unsupportedParams the params that are no longer supported
  _setUnsupportedParams: (keys, commonParams, previousTabId) ->
    for key in keys
      param = @_params[key]
      continue unless param
      if commonParams.includes(key)
        @_unsupportedParams["search_tab_#{previousTabId}_#{key}"] = param
      else
        @_unsupportedParams[key] = param
      @deleteParam(key)

  # Move from @_unsupportedParams the params that are now supported
  _setSupportedParams: (stillUnsupported, commonParams, tabId) ->
    nowSupported = {}
    for key, val of @_unsupportedParams
      continue if stillUnsupported.includes(key)
      if key.startsWith('search_tab_')
        continue unless key.includes("search_tab_#{tabId}")
        nowSupported[key.replace("search_tab_#{tabId}_", "")] = @_unsupportedParams[key]
      else
        nowSupported[key] = val
      delete @_unsupportedParams[key]
    @setEach({ params: nowSupported })

  handleUnsupported: ({ keys, commonParams, previousTabId, tabId }) ->
    @_setUnsupportedParams(keys, commonParams, previousTabId)
    @_setSupportedParams(keys, commonParams, tabId)

  setUnsupported: (tabs) ->
    unsupportedParams = {}
    for tab in tabs
      defaultTypeIds = tab.defaultTypeIds
      continue unless defaultTypeIds
      unsupportedParams["search_tab_#{tab.id}_type_ids"] = defaultTypeIds
    @_unsupportedParams = unsupportedParams

LP.module('Searches').ParamStore = ParamStore
